import {getOrLoadRemote} from './getOrLoadRemote';

export function loadExposed<T>(remote: string, module: string, url: string) {
    return async (): Promise<T> => {
        await getOrLoadRemote(remote, url);
        // @ts-expect-error: `remote` is remote ref which is just a string
        const container = window[remote];
        const factory = await container.get(module);
        return factory();
    };
}
